import axios from 'axios'

const baseUrl = process.env.BACKEND_URL
console.log('teamsService > baseUrl:', baseUrl)

export function getGames(tenantId) {
  if (tenantId) {
    return axios({
      method: 'get',
      url: `${baseUrl}/tenants/${tenantId}/games`,
    })
  }
  return axios({
    method: 'get',
    url: `${baseUrl}/games`,
  })
}



// WEBPACK FOOTER //
// ./src/services/gameService.js